import { Component, OnInit, Input } from '@angular/core';
import { CNPatient } from 'src/app/models/cnpatient';

@Component({
  selector: 'app-patient',
  template: `
    <p>
      patient works!
    </p>
  `,
  styleUrls: ['./patient.component.scss']
})
export class PatientComponent implements OnInit {

  @Input() patient: any;
  @Input() displaymode = 'full';

  constructor() { }

  ngOnInit(): void {
  }

}
